import { m } from 'framer-motion'
// @mui
// @mui
import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
import { Button, Box, Container, Typography } from '@mui/material'

import { MotionViewport, varFade } from '../../components/animate'
import { PATH_PAGE } from '../../routes/paths'

const StyledRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(15, 0),
  },
}))

// ----------------------------------------------------------------------

export default function HomeHaulwithUs() {
  return (
    <StyledRoot>
      <Container component={MotionViewport}>
        <Box
          gap={{ xs: 3, lg: 5 }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: 'common.black',
            maxWidth: 'auto',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              textAlign: 'center',
              maxWidth: 1000,
              color: 'common.black', // Change text color to black
              lineHeight: '1.1em',
              fontWeight: 50,
              letterSpacing: '-0.04em',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif', // Use Apple system font
            }}
          >
            Delivering a More Sustainable Supply Chain, Together
          </Typography>
          <m.div variants={varFade().inUp}>
            <Typography
              fontSize={{ xs: 10, md: 20 }}
              sx={{
                mx: 'auto',
                maxWidth: 640,
                color: 'text.dark',
                lineHeight: 1.2,
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif', // Use Apple system font
              }}
            >
              Our carriers are our greatest competitive advantage. We've built a culture of respect, fair pay, and seamless booking to help
              you grow your career and play a part in driving the future of a better supply chain excellence.
            </Typography>
          </m.div>
          <div>
            <Button
              variant="contained"
              component={RouterLink}
              to={PATH_PAGE.carriers}
              sx={{
                borderRadius: '999px',
                padding: '12px 32px',
              }}
            >
              Haul with us
            </Button>
          </div>
        </Box>
      </Container>
    </StyledRoot>
  )
}
